var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#333D4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3994 22.3846L18.8609 16.8461C20.2921 15.0783 21.1494 12.8268 21.1494 10.375C21.1494 4.69111 16.5417 0.083374 10.8578 0.083374C5.17384 0.083374 0.566101 4.69111 0.566101 10.375C0.566101 16.059 5.17384 20.6667 10.8578 20.6667C13.3095 20.6667 15.561 19.8094 17.3289 18.3782L22.8674 23.9167L24.3994 22.3846ZM18.9829 10.3752C18.9829 14.8625 15.3452 18.5002 10.8579 18.5002C6.37061 18.5002 2.73292 14.8625 2.73292 10.3752C2.73292 5.88788 6.37061 2.25019 10.8579 2.25019C15.3452 2.25019 18.9829 5.88788 18.9829 10.3752Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.c33c52bad50a363d1fddeb16fe010032.svg";
export { ForwardRef as ReactComponent };